// extracted by mini-css-extract-plugin
export default {"cookiesAlert":"_61frC","text":"_2KWSc","ctas":"_31vx8","link":"_1EBdp","close":"_2dsA_"};